import * as ng from 'angular';
import { StPipe } from './st-pipe.directive';

export const StPipeModule: string =
    ng.module('st-pipe', [
    ])
        .directive('stPipe', StPipe)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-pipe/st-pipe.module.ts